import { appSelector } from "@/redux/selectors/app.selector";
import { useSelector } from "@/redux/store";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";

export const PostHogIdentifier = () => {
  const posthog = usePostHog();
  const user = useSelector(appSelector.user);
  const previousUserIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!posthog) return;

    const currentUserId = user?.lassoUserId;

    // User logged in or changed
    if (currentUserId && currentUserId !== previousUserIdRef.current) {
      posthog.identify(currentUserId, {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.role,
        organizationId: user.organizationId,
        organizationName: user.organizationName,
        $set_once: {
          date_of_first_webapp_log_in: new Date().toISOString(),
        },
      });
      previousUserIdRef.current = currentUserId;
    }

    // User logged out
    if (!currentUserId && previousUserIdRef.current) {
      posthog.reset();
      previousUserIdRef.current = undefined;
    }
  }, [posthog, user]);

  return null;
};
